import React, { Component } from 'react';
import ReactHtmlParser from 'react-html-parser';
import { formatMoney } from '../ShoppingCartUtils/Helpers';
import CharacterCountEllipsis from '../../helpers/CharacterCountEllipsis.js';

class SkyeTileCardV2 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            trimmedTitle: ''
        }
        this.titleInspect;
        this.handleCardTitle = this._handleCardTitle.bind(this);
    }

    componentDidMount() {
        this.titleInspect = new CharacterCountEllipsis(this.props.title, 33, 2048);
        this.handleCardTitle();

        window.addEventListener('deviceorientation', this.handleCardTitle);
    }
    /**
     * @method _handleCardTitle - Applies the code from the CharacterCountEllipses class which trims titles and
     * adds ellipses based on parameters.
     */
    _handleCardTitle() {
        this.setState({ trimmedTitle: ReactHtmlParser(this.titleInspect.getModifiedEllipsisString()) });
    }

    render() {
        const productType = (this.props.product_type === 'course') ? 'Course' : 'Suite';
        return (
            <React.Fragment>
                <a href={this.props.link} className="course-tile__block">
                    <div className="course-tile__card card">
                        <div className="course-tile__image__wrapper">
                            <div className="course-tile__image__wrapper__layer"></div>
                            <img src={(this.props.image) ? this.props.image : 'https://cdn.skyelearning.com/static/course-icon-template.png'} className="card-img-top course-tile__image" alt={(this.props.product_type === 'course') ? `${ReactHtmlParser(this.props.title)} Course icon,` : `${ReactHtmlParser(this.props.title)} Suite icon,`} />
                            {(this.props.product_type === 'course') ? '' : <img className="fltr course-tile__cert__badge" src="https://cdn.skyelearning.com/static/certificate_badge.png" alt="Certificate badge icon," />}
                        </div>
                        <div className="card-body course-tile__card__body ubuntu">
                            <h4 className="course-tile__title card-title" aria-label={'The ' + productType + ' title is ' + ReactHtmlParser(this.props.title) + ','}><span aria-hidden="true">{this.state.trimmedTitle}</span></h4>
                            <p className="course-tile__category card-text ubuntu--medium--italic" aria-label={'The ' + productType + ' category is ' + ReactHtmlParser(this.props.category) + ','}><span aria-hidden="true">{ReactHtmlParser(this.props.category)}</span></p>
                            <div className="course-tile__metrics card-text row">
                                <div className="course-tile__rating" aria-label={'The rating is ' + this.props.rating + ','}><span aria-hidden="true"><i className="course-tile__rating__icon fas fa-thumbs-up" aria-hidden="true"></i>&nbsp;{this.props.rating}</span></div>
                                <div className="course-tile__duration" aria-label={'The course duration is ' + this.props.duration + ','}><span aria-hidden="true"><i className="course-tile__duration__icon fas fa-clock" aria-hidden="true"></i>&nbsp;{this.props.duration}</span></div>
                                <div className="course-tile__pricing">
                                    {this.props.strikePrice ? <span className="course-tile__strikethru st-thru" aria-label={'The striked price is $' + formatMoney(this.props.strikePrice, 0, '', ',') + ','}><span aria-hidden="true">${formatMoney(this.props.strikePrice, 0, '', ',')}</span></span> : ''}
                                    {this.props.price ? <span className="course-tile__price" aria-label={'The current price is $' + formatMoney(this.props.price, 0, '', ',') + ','}><span aria-hidden="true">${formatMoney(this.props.price, 0, '', ',')}</span></span> : ''}
                                </div>
                            </div>
                        </div>
                    </div>
                </a>
            </React.Fragment>
        );
    }
}

export default SkyeTileCardV2;